import { baseDialogStyles} from '../baseDialogStyles.js';
import { mergeDeepRight } from 'ramda';

export const styles = (theme) => {
    const _baseDialogStyles = baseDialogStyles(theme);
    const _styles = {
        header: {
            background: theme.palette.primary.main,
            color: theme.palette.text.white,
        },
        copyTextField: {
            fontWeight: 500
        }
    };

    return mergeDeepRight(_baseDialogStyles, _styles);
};